import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "left-card-border" }
const _hoisted_2 = { class: "border" }
const _hoisted_3 = {
  key: 0,
  class: "top"
}
const _hoisted_4 = {
  key: 1,
  class: "bottom"
}
const _hoisted_5 = {
  key: 0,
  class: "icon-container"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "telehealth-roundel" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-video" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "card-content" }
const _hoisted_9 = { class: "header" }
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = {
  key: 0,
  class: "attachment-marker icon-attachments"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    onMouseup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('mouseup'))),
    onTouchend: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('mouseup'))),
    onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('mousedown'))),
    onTouchstart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('mousedown'))),
    class: _normalizeClass(["selection-card", _ctx.cardClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.borderText)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.borderText.top), 1))
          : _createCommentVNode("", true),
        (_ctx.borderText)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.borderText.bottom), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.teleHealth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.header), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["primary", {regular: _ctx.regular}]),
        ref: "primaryText"
      }, _toDisplayString(_ctx.primary), 3),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.footer), 1),
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.attachment)
      ? (_openBlock(), _createElementBlock("i", _hoisted_11))
      : _createCommentVNode("", true),
    (_ctx.hasDelete)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete'))),
          class: "icon-cancel"
        }))
      : _createCommentVNode("", true)
  ], 34))
}